import ProductCard from './ProductCard';
import { useFeaturedProducts } from '@/hooks/useProducts';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

const FeaturedProducts = () => {
  const { data: products, isLoading, error } = useFeaturedProducts();

  if (isLoading) {
    return (
      <section id="productos" className="py-24 lg:py-32 bg-gradient-to-b from-background to-onyx-light">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center">Cargando productos...</div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section id="productos" className="py-24 lg:py-32 bg-gradient-to-b from-background to-onyx-light">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center">Error al cargar productos.</div>
        </div>
      </section>
    );
  }

  return (
    <section id="productos" className="py-24 lg:py-32 bg-gradient-to-b from-background to-onyx-light">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="font-body text-sm uppercase tracking-[0.3em] text-primary mb-4 block">
            Colecciones
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground mb-6">
            Productos Destacados
          </h2>
          <div className="line-gold w-24 mx-auto mb-6" />
          <p className="font-body text-muted-foreground leading-relaxed">
            Descubre nuestra selección de perfumes y joyas más exclusivas. 
            Cada pieza ha sido cuidadosamente elegida para reflejar la esencia de Tyche.
          </p>
          <div className="mt-8">
            <Button asChild variant="outline" size="lg">
              <Link to="/catalogo" className="flex items-center gap-2">
                Ver catálogo completo
                <ArrowRight className="h-4 w-4" />
              </Link>
            </Button>
          </div>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 lg:gap-8">
          {products?.map((product, index) => {
            // Obtenemos el nombre de la primera categoría, si la tiene
            const categoryName = product.categories?.length > 0 
              ? product.categories[0].name 
              : 'Sin categoría';

            return (
              <div
                key={product.slug || product.$id}
                className="opacity-0 animate-fade-in"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <Link to={`/producto/${product.slug}`}>
                  <ProductCard
                    name={product.name}
                    description={product.description}
                    category={categoryName}
                    image={product.image_url}
                    slug={product.slug}
                  />
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
